import datasetParser from "@Dataset/datasetParser";
import {useState} from "react";
import MobileSwiper from "@Features/mobileSwiper/components/MobileSwiper";
import {useTableScroll} from "@Pages/stationToStation/features/travelTable/hooks/useTableScroll";
import {TableScroll} from "@Pages/stationToStation/features/travelTable/components/TableScroll";
import {TravelTableHeader} from "@Pages/stationToStation/features/travelTable/components/TravelTableHeader";
import {TravelTableBody} from "@Pages/stationToStation/features/travelTable/components/TravelTableBody";

export const TravelTable = () => {
    const parsedData = datasetParser({id: 'travel-table'});
    const [hoveredColumnIndex, setHoveredColumnIndex] = useState(null);
    const {
        scrollRight,
        scrollLeft,
        handleScroll,
        isLeftDisabled,
        isRightDisabled,
    } = useTableScroll();

    return (
        <>
            <TableScroll
                scrollLeft={scrollLeft}
                scrollRight={scrollRight}
                isLeftDisabled={isLeftDisabled}
                isRightDisabled={isRightDisabled}
            />
            <MobileSwiper className="travel-table-container" onSwipe={handleScroll}>
                <table
                    onMouseLeave={() => {
                        setHoveredColumnIndex(0)
                    }}
                >
                    <TravelTableHeader setHoveredColumnIndex={setHoveredColumnIndex}/>
                    <TravelTableBody
                        parsedData={parsedData}
                        setHoveredColumnIndex={setHoveredColumnIndex}
                        hoveredColumnIndex={hoveredColumnIndex}
                    />
                </table>
            </MobileSwiper>
        </>
    );
}